import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { AppStoreBadges } from "@/components/AppStoreBadges";
import { PrimaryButton } from "@/components/common";

const FEATHER = {
  WebkitMaskImage: "radial-gradient(ellipse 70% 68% at 50% 48%, #000 46%, rgba(0,0,0,0.55) 66%, transparent 82%)",
  maskImage: "radial-gradient(ellipse 70% 68% at 50% 48%, #000 46%, rgba(0,0,0,0.55) 66%, transparent 82%)",
};

export default function Register() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-cream text-ink font-sans overflow-x-clip flex flex-col">
      <div className="px-6 sm:px-10 lg:px-16 py-6">
        <Link to="/" data-testid="auth-logo"><Logo /></Link>
      </div>

      <div className="flex-1 grid lg:grid-cols-2 items-center gap-6 lg:gap-10 px-6 sm:px-10 lg:px-16 pb-10 max-w-7xl mx-auto w-full">
        {/* Mascot replaces the old form (left side) */}
        <div className="relative order-1 mx-auto w-full max-w-md">
          <div className="pointer-events-none absolute inset-6 rounded-full bg-sage/15 blur-3xl" />
          <video
            data-testid="auth-mascot-video"
            className="relative w-full h-auto nt-float"
            style={FEATHER}
            src="/assets/mascot.mp4"
            poster="/assets/mascot-poster.jpg"
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
          />
        </div>

        {/* Welcome + guest continue (no login, no email) */}
        <div className="order-2 max-w-md w-full mx-auto text-center lg:text-left">
          <p className="text-xs font-mono uppercase tracking-[0.15em] text-sage-hover">Welcome to Next Time</p>
          <h1 className="mt-4 font-serif font-bold tracking-tight text-4xl sm:text-5xl text-ink leading-[1.08]">
            Handle it better<br />next time.
          </h1>
          <p className="mt-5 text-lg text-ink-muted leading-relaxed">
            Learn from difficult moments, rehearse the conversations that matter, and walk in prepared. No account, no email, just start.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
            <PrimaryButton onClick={() => navigate("/tour")} className="text-base w-full sm:w-auto" data-testid="auth-learn-more-btn">
              Learn More
            </PrimaryButton>
          </div>
          <div className="mt-8">
            <p className="text-xs font-mono uppercase tracking-wider text-ink-muted mb-3">Get the mobile app now</p>
            <AppStoreBadges className="justify-center lg:justify-start" />
          </div>
        </div>
      </div>
    </div>
  );
}
